<template>
  <app-page :labelledby="resolvedTitleId" full-width>
    <page-header
      :title-id="resolvedTitleId"
      :title="title"
      :description="description"
    >
      <template v-if="$slots.status" #status>
        <slot name="status" />
      </template>
      <template v-if="$slots.metadata" #metadata>
        <slot name="metadata" />
      </template>
      <template v-if="$slots.actions" #actions>
        <slot name="actions" />
      </template>
    </page-header>
    <slot />
  </app-page>
</template>

<script>
import { getCurrentInstance } from 'vue'
import AppPage from './AppPage.vue'
import PageHeader from './PageHeader.vue'

export default {
  name: 'RegistryPage',
  components: { AppPage, PageHeader },
  props: {
    title: { type: String, required: true },
    description: { type: String, default: '' },
    titleId: { type: String, default: '' }
  },
  setup(props) {
    const instance = getCurrentInstance()
    return {
      resolvedTitleId: props.titleId || `registry-page-${instance.uid}-title`
    }
  }
}
</script>
